<template>
  <div class="globalHead" v-show="this.$route.path === '/singleEventList'">
    <!-- <div id="barrierfree" src="/accessiblereading/" style="display:none;"></div> -->
    <div class="marginAuto" v-show="false">
      <div class="toppart">
        <div class="left">
          <div class="middle">
            <img
              class="middleImg"
              src="/cms_files/filemanager/1474096170/picture/202311/5576f37bdf344dd89ca2949fdb458f32.png"
              alt=""
            />
          </div>
          <a-row style="display: inline-block">
            <a-col :span="24"></a-col>
            <a-col :span="24" v-if="isShowArea">
              <!-- <div class="district" >
                <ellipsis :length="20" >{{ districtValue }}</ellipsis>
              </div> -->
              <div
                style="display: inline-block; margin-left: 16px; background: #eaf3ff 0.2; margin-top: 5px;"
                @click="showArea"
              >
                <a-tree-select
                  style="pointer-events: none"
                  class="district-select"
                  v-if="selectVisible"
                  v-model="areaName"
                  :dropdown-style="{ maxHeight: '500px', overflow: 'auto' }"
                  :tree-data="treeData"
                  placeholder="选择区域"
                  @change="districtSelect"
                />
              </div>
              <AreaModal
                ref="areapage"
                @ok="districtSelect"
                @changeSameName="changeSameName"
                @changeSameNameSingle="changeSameNameSingle"
              />
            </a-col>
            <a-col :span="24"></a-col>
          </a-row>
        </div>
        <div style="float: right; cursor: pointer">
          <div class="buttons">
            <div class="rightButtonFirst">
              <span @click="jumpZwfw" style="margin-right:10px;">国家政务服务平台</span>
              <span style="margin-right:10px;">|</span>
              <span @click="findProcess">无障碍浏览</span>
            </div>
            <div style="display: flex; justify-content: end;">
              <div class="rightButtonSecond">
                <div style="width: 72px; height: 18px; line-height: 18px" @click="toggleToolBar('2');">长辈模式</div>
              </div>
              <div class="xldBox" v-if="isOnline">
                <img class="xldImg" :src="xldImg" @click="openWdxx" alt="">
                <div :class="unReadNum > 99 ? 'bell-large-number' : 'unReadNum'" v-if="unReadNum">{{ unReadNum > 99 ? '99+' : unReadNum }}</div>
                <!-- <div class="unReadNum" >99+</div> -->
              </div>
              <div class="rightButtonThird" v-if="!isOnline">
                <div class="login" @click="toLogin('l')">
                  <a-spin :spinning="loadingLogin">登录</a-spin>
                </div>
                <div class="device"></div>
                <div class="regist" @click="toLogin('r')">
                  <a-spin :spinning="loadingRegist">注册</a-spin>
                </div>
              </div>
              <div class="rightButtonThird" v-else>
                <a-popover class="">
                  <span class="menuTitle" slot="content" @click="toRecord">
                    <div>用户空间</div>
                  </span>
                  <span slot="content" style="display: flex;height: 1px;background-color: #cccccc;"></span>
                  <span class="menuTitle" slot="content" @click="outLogin">
                    <div>退出登录</div>
                  </span>
                  <div style="display: flex; text-align: center; align-items: center; justify-content: center;width: 116px;">
                    <i class="header" target="_self" rel="noopener noreferrer"></i>
                    <span
                      style="
                        color: #4493F5;
                        font-size: 16px;
                        max-width: 65px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                    >
                      {{ loginName }}
                    </span>
                  </div>
                </a-popover>
              </div>
            </div>
          </div>
          <!-- <div class="buttons">
            <a @click="findProcess">办件进度查询</a>
            <a-popover>
              <span class="menuTitle" slot="content" @click="toRecord">
                <p>查看办事记录</p>
              </span>
              <span class="menuTitle" slot="content" @click="toMyMaterial">
                <p>我的材料库</p>
              </span>
              <span class="menuTitle" slot="content" @click="outLogin">
                <p style="margin-bottom: 0px">退出</p>
              </span>
              <div
                style="
                  cursor: pointer;
                  font-size: 16px;
                  letter-spacing: 2px;
                  color: #333;
                  margin-left: 8px;
                "
              >
                {{ loginName }}
              </div>
            </a-popover>
          </div> -->
        </div>
      </div>
      <div class="bottompart" v-if="false">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item key="index" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">首页</span>
          </a-menu-item>
          <a-menu-item key="personal" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">个人服务</span>
          </a-menu-item>
          <a-menu-item
            key="legalperson"
            style="font-size: 18px; margin-right: 50px; font-weight: 500;"
            @click="changeType"
          >
            <span class="typeTitle">法人服务</span>
          </a-menu-item>
          <a-menu-item key="convenient" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">便民服务</span>
          </a-menu-item>
          <a-menu-item key="list" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">服务清单</span>
          </a-menu-item>
          <a-menu-item key="interaction" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">政民互动</span>
          </a-menu-item>
          <a-menu-item key="hcp" style="font-size: 18px; margin-right: 50px; font-weight: 500;" @click="changeType">
            <span class="typeTitle">好差评</span>
          </a-menu-item>
          <!-- <a-menu-item key="oneThing" style="font-size: 18px; margin-right: 50px;" @click="changeType">
            <span class="typeTitle">一件事</span></span>
          </a-menu-item>
          <a-menu-item key="label" style="font-size: 18px; margin-right: 50px;" @click="changeType">
            <span class="typeTitle">标签事项</span>
          </a-menu-item> -->
        </a-menu>
      </div>
    </div>
    <a-modal :visible="visible" title="提示" @ok="handleOk" @cancel="handleCancel">
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">您确认要退出当前登录吗？</p>
        </a-col>
      </a-row>
    </a-modal>

    <a-row style="display: inline-block" class="area-select-box">
      <a-col :span="24"></a-col>
      <a-col :span="24" v-if="isShowArea">
        <!-- <div class="district" >
                <ellipsis :length="20" >{{ districtValue }}</ellipsis>
              </div> -->
        <div
          style="display: inline-block; margin-left: 16px; background: #eaf3ff 0.2;"
          @click="showArea"
        >
          <!-- <a-tree-select
            style="pointer-events: none"
            class="district-select"
            v-if="selectVisible"
            v-model="areaName"
            :dropdown-style="{ maxHeight: '500px', overflow: 'auto' }"
            :tree-data="treeData"
            placeholder="选择区域"
            @change="districtSelect"
          /> -->
          <span class="district-select" style="pointer-events: none;">{{ areaName }}</span>
        </div>
        <AreaModal
          ref="areapage"
          @ok="districtSelect"
          @changeSameName="changeSameName"
          @changeSameNameSingle="changeSameNameSingle"
        />
      </a-col>
      <a-col :span="24"></a-col>
    </a-row>
  </div>
</template>

<script>
import IconEmblem from '@/assets/jiopweb3.0.0/emblem.svg?inline'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb.js'
import { Ellipsis } from 'jpaas-component'
import IconCaretDown from '@ant-design/icons/svg/outline/caret-down.svg?inline'
import AreaModal from './AreaModal'

export default {
  components: {
    Ellipsis,
    AreaModal
  },
  data () {
    return {
      xldImg: require('../../assets/xld.png'),
      unReadNum: '',
      userType: '',
      accessToken: '',
      IconEmblem,
      IconCaretDown,
      current: [],
      isOnline: false,
      loadingRegist: false,
      loadingLogin: false,
      loginName: '',
      visible: false,
      selectVisible: true,
      selectedKeys: [],
      // districtValue: '',
      districtId: '',
      value: undefined,
      areaName: '',
      groupData: [],
      isShowArea: true,
      treeData: [
        { id: 1, pId: 0, value: '1', title: 'Expand to load' },
        { id: 2, pId: 0, value: '2', title: 'Expand to load' },
        { id: 3, pId: 0, value: '3', title: 'Tree Node', isLeaf: true }
      ]
    }
  },
  created () {
    if (
      this.$route.name === 'GuideSimple' ||
      this.$route.name === 'GuideComplex' ||
      this.$route.name === 'oneThingGuide' ||
      this.$route.name === 'singleEventList' ||
      this.$route.name === 'ServiceList' ||
      this.$route.name === 'fillInstruction' ||
      this.$route.name === 'selectSitution' ||
      this.$route.name === 'matterForm' ||
      this.$route.name === 'uploadMaterial' ||
      this.$route.name === 'receiveInfo' ||
      this.$route.name === 'handlingMatterSuccess' ||
      this.$route.name === 'confirmInfo'
    ) {
      this.isShowArea = true
    } else {
      this.isShowArea = false
    }
    // 缓存中没有用户信息时调用获取用户信息的接口
    if (!sessionStorage.getItem('JiopUserInfo') || !JSON.parse(sessionStorage.getItem('JiopUserInfo')).isLogin) {
      this.getLoginInfo()
    } else {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      const userParams = JSON.parse(userInfo.desensitizeUser)
      this.isOnline = userInfo.isLogin
      this.loginName = userParams.corporationName ? userParams.corporationName : userParams.name
      if (
        this.$route.name === 'GuideSimple' ||
        this.$route.name === 'GuideComplex' ||
        this.$route.name === 'queryHandling' ||
        this.$route.name === 'handlingInfo' ||
        this.$route.name === 'ucenter' ||
        this.$route.name === 'oneThingGuide' ||
        this.$route.name === 'fillInstruction' ||
        this.$route.name === 'selectSitution' ||
        this.$route.name === 'matterForm' ||
        this.$route.name === 'uploadMaterial' ||
        this.$route.name === 'receiveInfo' ||
        this.$route.name === 'handlingMatterSuccess' ||
        this.$route.name === 'confirmInfo'
      ) {
        this.current = []
        // const type = parseInt(userParams.userType) === 1 ? ['personal'] : ['legalperson']
        const type = sessionStorage.getItem('JiopSelectItem')
          ? [sessionStorage.getItem('JiopSelectItem')]
          : parseInt(userParams.userType) === 1
            ? ['personal']
            : ['legalperson'] // 有缓存要按照缓存的来
        sessionStorage.setItem('JiopSelectItem', type[0])
      } else {
        this.current = sessionStorage.getItem('JiopSelectItem')
          ? [sessionStorage.getItem('JiopSelectItem')]
          : parseInt(userParams.userType) === 1
            ? ['personal']
            : ['legalperson']
        sessionStorage.setItem('JiopSelectItem', this.current[0])
        if (this.$route.query.bannerType) {
          this.current = this.$route.query.bannerType
        }
        this.$emit('updateData', this.current)
      }
      this.getLoginInfo()
    }
    if (this.isOnline) {
      // this.unReadNumFn()
      this.getLoginInfo()
    }
    // 获取地区数据
    // this.getTree('0')
    const JIOP_AREA = JSON.parse(sessionStorage.getItem('JIOP_AREA'))
    console.log(JIOP_AREA[0], 'JIOP_AREA')
    if (JIOP_AREA) {
      this.areaName = JIOP_AREA[0].name
    }
  },
  methods: {
    openWdxx () {
      window.open('/yhkj/wdxx/index.html')
    },
    jumpZwfw () {
      window.location.href = 'https://gjzwfw.www.gov.cn/index.html'
    },
    // 切换区划时获取同名的一件事
    changeSameName (distinctId, districtName, sessionData) {
      this.$emit('updateSame', distinctId, districtName, sessionData)
    },
    districtSelect (value, label, codeId) {
      this.value = label[0]
      // this.districtValue = label[0]
      this.districtId = value
      sessionStorage.setItem('districtId', value)
      this.$emit('updateGroup', value, label, codeId)
    },
    changeSameNameSingle (distinctId, districtName, type, sessionData) {
      if (type === 'simple') {
        this.$emit('updateSimpleSame', distinctId, districtName, sessionData)
      } else {
        this.$emit('updateDetailSame', distinctId, districtName, sessionData)
      }
    },
    showArea () {
      // this.$refs.areapage.open()
    },
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    unReadNumFn () {
      const params = {
        appType: 1,
        userType: this.getCookieData('userType'),
        accessToken: this.getCookieData('accessToken')
      }
      jiopWebAPI.unReadNum(params).then(res => {
        console.log(res, 'res')
        if (!res.success && res.message === '获取用户信息失败') {
          this.isOnline = false
          this.getLoginInfo()
          return
        }
        if (res.success) {
          this.unReadNum = res.data.unReadNum
          console.log(this.unReadNum, 'this.unReadNum')
        }
      })
    },
    // onLoadData (treeNode) {
    //   return new Promise((resolve, reject) => {
    //     if (treeNode.dataRef.children) {
    //       resolve()
    //       return
    //     }
    //     jiopWebAPI.districtList({ districtId: treeNode.value }).then(res => {
    //       const tree = res.data.districtList.map(item => {
    //         item.id = item.iid
    //         item.pId = item.pid
    //         item.value = item.iid
    //         item.title = item.name
    //         item.isLeaf = !item.hasChild
    //         return item
    //       })
    //       treeNode.dataRef.children = tree
    //       resolve()
    //     })
    //   })
    // },
    getTree (value) {
      const that = this
      jiopWebAPI.districtList({ districtId: value }).then(res => {
        if (res.success) {
          console.log(res.data, '===>res.data')
          that.treeData = res.data.districtList.map(item => {
            item.id = item.iid
            item.pId = item.pid
            item.value = item.iid
            item.title = item.name
            item.isLeaf = !item.hasChild
            return item
          })
          if (this.$route.query.areacode && value === '0') {
            res.data.districtList.forEach(item => {
              if (this.$route.query.areacode === item.value) {
                this.value = item.name
              }
            })
          }
          if (!sessionStorage.getItem('JIOP_AREA')) {
            // that.districtValue = that.treeData[0].title
            that.districtId = that.treeData[0].iid
            sessionStorage.setItem('districtId', that.districtId)
            this.districtSelect(
              res.data.districtList[0].iid,
              [res.data.districtList[0].name],
              res.data.districtList[0].codeId
            )
          } else {
            const josnArray = JSON.parse(sessionStorage.getItem('JIOP_AREA'))
            const length = josnArray.length
            // that.districtValue = josnArray[length - 1].name
            that.districtId = josnArray[length - 1].iid
            sessionStorage.setItem('districtId', that.districtId)
            this.districtSelect(
              josnArray[length - 1].iid,
              [josnArray[length - 1].name],
              [josnArray[length - 1].codeId]
            )
          }
        }
      })
    },
    findProcess () {
      if (this.$route.name !== 'queryHandling') {
        const url = this.$router.resolve({
          path: '/queryHandling'
        })
        window.open(url.href, '_blank')
      }
    },
    changeType (item) {
      if (item.key === 'index') {
        window.location.href = '/index.html'
      } else if (item.key === 'convenient') {
        window.location.href = '/bmfw/index.html'
      } else if (item.key === 'list') {
        window.location.href = '/fwqd/index.html'
      } else if (item.key === 'interaction') {
        window.location.href = '/zmhd/index.html'
      } else if (item.key === 'hcp') {
        window.location.href = '/hcp/index.html'
      } else if (item.key === 'legalperson') {
        // this.current = [item.key]
        // sessionStorage.setItem('JiopSelectItem', this.current[0])
        // this.$emit('updateData', this.current)
        // if (this.$route.name !== 'singleEventList') {
        //   this.$router.push('./singleEventList')
        // }
        window.location.href = '/jiopweb/singleEventList?bannerType=legalperson'
      } else if (item.key === 'personal') {
        window.location.href = '/jiopweb/singleEventList?bannerType=personal'
      } else if (item.key === 'oneThing') {
        window.location.href = '/jiopweb/singleEventList?bannerType=oneThing'
      } else if (item.key === 'label') {
        window.location.href = '/jiopweb/singleEventList?bannerType=label'
      }
    },
    getLoginInfo () {
      const that = this
      jiopWebAPI
        .isLogin({ userType: 1, appType: 1 })
        .then(res => {
          console.log('确实是否登录', res.success, '2222', res.data)
          if (res.success) {
            sessionStorage.setItem('JiopUserInfo', JSON.stringify(res.data))
            console.log('成功塞用户信息')
            that.isOnline = res.data.isLogin
            if (that.isOnline) {
              console.log('确认登录')
              const userInfo = JSON.parse(res.data.desensitizeUser)
              that.loginName = userInfo.corporationName ? userInfo.corporationName : userInfo.name
              that.userType = userInfo.userType
              that.accessToken = userInfo.accessToken
              // this.unReadNumFn()
              // 登录状态，根据用户类型默认选择个人或法人服务
              if (
                that.$route.name === 'GuideSimple' ||
                that.$route.name === 'GuideComplex' ||
                that.$route.name === 'queryHandling' ||
                that.$route.name === 'handlingInfo' ||
                that.$route.name === 'ucenter' ||
                that.$route.name === 'oneThingGuide' ||
                that.$route.name === 'fillInstruction' ||
                that.$route.name === 'selectSitution' ||
                that.$route.name === 'matterForm' ||
                that.$route.name === 'uploadMaterial' ||
                that.$route.name === 'receiveInfo' ||
                that.$route.name === 'handlingMatterSuccess' ||
                that.$route.name === 'confirmInfo'
              ) {
                that.current = []
                // 否则直接在其它页面登录的数据没有JiopSelectItem数据，就会判法人个人不匹配
                const type = parseInt(userInfo.userType) === 1 ? ['personal'] : ['legalperson']
                sessionStorage.setItem('JiopSelectItem', type[0])
              } else {
                that.current = sessionStorage.getItem('JiopSelectItem')
                  ? [sessionStorage.getItem('JiopSelectItem')]
                  : parseInt(userInfo.userType) === 1
                    ? ['personal']
                    : ['legalperson']
                sessionStorage.setItem('JiopSelectItem', that.current[0])
                that.$emit('updateData', that.current)
              }
            } else {
              // 未登录状态下
              if (
                that.$route.name === 'GuideSimple' ||
                that.$route.name === 'GuideComplex' ||
                that.$route.name === 'queryHandling' ||
                that.$route.name === 'handlingInfo' ||
                that.$route.name === 'ucenter' ||
                that.$route.name === 'oneThingGuide' ||
                that.$route.name === 'fillInstruction' ||
                that.$route.name === 'selectSitution' ||
                that.$route.name === 'matterForm' ||
                that.$route.name === 'uploadMaterial' ||
                that.$route.name === 'receiveInfo' ||
                that.$route.name === 'handlingMatterSuccess' ||
                that.$route.name === 'confirmInfo'
              ) {
                that.current = []
              } else {
                that.current = sessionStorage.getItem('JiopSelectItem')
                  ? [sessionStorage.getItem('JiopSelectItem')]
                  : ['personal']
                that.$emit('updateData', that.current)
              }
            }
            if (this.$route.query.bannerType) {
              this.current = this.$route.query.bannerType
            }
          } else {
            that.isOnline = false
            if (
              that.$route.name === 'GuideSimple' ||
              that.$route.name === 'GuideComplex' ||
              that.$route.name === 'queryHandling' ||
              that.$route.name === 'handlingInfo' ||
              that.$route.name === 'ucenter' ||
              that.$route.name === 'oneThingGuide' ||
              that.$route.name === 'fillInstruction' ||
              that.$route.name === 'selectSitution' ||
              that.$route.name === 'matterForm' ||
              that.$route.name === 'uploadMaterial' ||
              that.$route.name === 'receiveInfo' ||
              that.$route.name === 'handlingMatterSuccess' ||
              that.$route.name === 'confirmInfo'
            ) {
              that.current = []
            } else {
              that.current = sessionStorage.getItem('JiopSelectItem')
                ? [sessionStorage.getItem('JiopSelectItem')]
                : ['personal']
              if (this.$route.query.bannerType) {
                this.current = this.$route.query.bannerType
              }
              that.$emit('updateData', that.current)
            }
          }
        })
        .catch(res => {
          that.isOnline = false
          if (
            that.$route.name === 'GuideSimple' ||
            that.$route.name === 'GuideComplex' ||
            that.$route.name === 'queryHandling' ||
            that.$route.name === 'handlingInfo' ||
            that.$route.name === 'ucenter' ||
            that.$route.name === 'oneThingGuide' ||
            that.$route.name === 'fillInstruction' ||
            that.$route.name === 'selectSitution' ||
            that.$route.name === 'matterForm' ||
            that.$route.name === 'uploadMaterial' ||
            that.$route.name === 'receiveInfo' ||
            that.$route.name === 'handlingMatterSuccess' ||
            that.$route.name === 'confirmInfo'
          ) {
            that.current = []
          } else {
            that.current = sessionStorage.getItem('JiopSelectItem')
              ? [sessionStorage.getItem('JiopSelectItem')]
              : ['personal']
            that.$emit('updateData', that.current)
          }
        })
    },

    toLogin (type) {
      // 本地环境使用
      // this.getUserLocalInfo()
      // 容器环境使用
      this.getUserOnlineInfo(type)
    },
    getUserLocalInfo () {
      // 测试数据，方便本地没有jis服务的时候登录使用
      const user = {
        // uid: 'ef73c549b8e548728ea84b26513f2aa6', // *旭
        // name: '*家伟',
        // userType: 1// 1：个人  0：法人
        uid: 'f6369f9e6da94d71b3ee20114e3591c0',
        name: '*啦啦',
        userType: 1
      }
      const stringJson = JSON.stringify(user)
      const param1 = {
        isLogin: true,
        encodeUser:
          '04192688a348112f7943dec7efa0fa7ea35d0994546ab701237690fd284c67ffbfa0253098ea79a0c1b0e313bc0d96dcbe7cd5a28d07107d4616cee213d4616b224ca7750c1c7f512825e39973fcff860f3c8d4b9eeb43133f76ab1bc88ba3eaa617f32d30e7384b526f3ab713a5cf06cfa9b8342e6297a394c6f005f3dfb79b420c4aa6f45c9778b68b98fda0e941fdc266440443c0aa100a6358fd249e88372a5b167aee675a1129958423c5acbca34b8293685459e36100134e5fb74ce58ba1190ae798ba242bd2ed64af3b8b3b21a22c975f5d36114c3c87bb819abbb92ae27548dd3bc04735b041e7a7c6b6d9c367b3767da3f50ad531c4d2d991eb3d62801abce04030275673a59816e66aad6decb443ff8caae1c39f3da847501341ebc31e508b596e5dffeed95b35b1078c9c173f1ab797b04fd96f14469f99ecf77953c9940edbc72ad0b1f01954cc0b80f9c418a15a1dfeeabbffe30e5d3e1eb28e12ffd8',
        desensitizeUser: stringJson
      }
      sessionStorage.setItem('JiopUserInfo', JSON.stringify(param1))
      location.reload()
    },
    getUserOnlineInfo (type) {
      const that = this
      if (type === 'r') {
        this.loadingRegist = true
      } else {
        this.loadingLogin = true
      }
      const params = this.$route.query || {}
      params.jiopWorkUrl = 'jiopweb' + this.$route.path
      jiopWebAPI.getLoginUrl({ params: JSON.stringify(params) }).then(res => {
        if (res.success) {
          if (res.data.url) {
            if (type === 'r') {
              that.loadingRegist = false
            } else {
              that.loadingLogin = false
            }
            window.location.href = res.data.url
          }
        }
      })
    },
    toRecord () {
      window.open('/yhkj/index.html')
    },
    toMyMaterial () {
      const url = this.$router.resolve({
        path: '/myMaterial'
      })
      window.open(url.href, '_blank')
    },
    outLogin () {
      this.visible = true
    },
    handleOk () {
      const that = this
      jiopWebAPI.outLogin().then(res => {
        if (res.success) {
          that.isOnline = false
          sessionStorage.removeItem('JiopUserInfo')
          sessionStorage.removeItem('JiopSelectItem')
          if (that.$route.name !== 'singleEventList') {
            that.$router.push({ path: '/singleEventList', query: { bannerType: 'personal' } })
          } else {
            location.reload()
          }
        }
      })
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.globalHead {
  // height: 115px;
  // box-shadow: 0px 15px 10px -12px rgb(240, 238, 238);
  // background: url(/cms_files/filemanager/1474096170/picture/202310/de283aee573f4a869a092eb7c43fd6a0.png) 0 0 no-repeat;
}
.marginAuto {
  width: 1200px;
  margin: auto;
}
.toppart {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  height: 50px;
  margin-top: 25px;
}
.left {
  float: left;
  display: flex;
  // align-items: center;
}
.typeTitle {
  // width: 514px;
  // height: 25px;
  // font-size: 18px;
  // letter-spacing: 0;
  // line-height: 25px;
  // font-weight: 500;

  width: auto;
  height: 47  px;
  position: relative;
  float: left;
  color: #333333;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // margin: 0 50px 0 0;
}
.district {
  display: inline-block;
  margin-left: 40px;

  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}
.district-select {
  display: inline-block;
  width: 120px;
  height: 40px;
  background-color: #F1F6FE;
  font-size: 16px;
  line-height: 40px;
  color: #333;
  text-align: center;
  /deep/.ant-select-selection {
    width: 120px;
    height: 40px;
    border-radius: 0;
  }
}
.middle {
  height: 59px;
  display: inline-block;
  .middleImg {
    width: 314px;
    height: 50px;
  }
  .fontClass {
    color: #000000;
    font-size: 26px;

    font-weight: 700;
    letter-spacing: 1.5px;
  }
  .smallFontClass {
    color: #000000;
    font-size: 12px;

    font-weight: 700;
    letter-spacing: 2.8px;
  }
}
.right {
  margin-left: 39px;
  float: right;
  height: 56px;
  display: inline-grid;
  .fontClass {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;

  }
}
.header {
  display: inline-block;
  position: relative;
  float: left;
  margin-right: 10px;
  width: 26px;
  height: 40px;
  border: none;
  margin-top: 0;
  background: url(/cms_files/filemanager/1474096170/picture/202311/56de5900e83140a3a87c76724f563c30.png) center center no-repeat;
}
/deep/ .ant-select-selection--single {
  width: 120px;
  height: 40px;
  background: #F0F6FF;
  border: 1px solid #F0F6FF;
  border-top-width: 1.02px;
}
/deep/ .ant-select-selection__placeholder {
  font-size: 18px;
  color: #333333;
  line-height: 18px;
}
/deep/ .ant-select-selection-selected-value {
  font-size: 18px;
  color: #333333;
  line-height: 18px;
}
/deep/ .ant-select-selection__rendered {
  margin-left: 12px;
}
/deep/ .ant-select-selection--single .ant-select-selection__rendered {
  margin-left: 25px;
  margin-top: 10px;
}
/deep/ .ant-select-arrow {
  right: 8px;
}
.buttons {
  display: flex;
  // height: 56px;
  margin-top: 5px;
  align-items: center;
  .rightButtonFirst {
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    text-align: right;
    margin-top: 2px;
  }
  .rightButtonSecond {
    margin-left: 20px;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    width: 109px;
    height: 40px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    background: #E9B162;
    font-weight: 500;
  }
  .rightButtonThird {
    margin-left: 10px;
    display: flex;
    width: 116px;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    background: #F0F6FF;
    .regist {
      width: 58px;
      height: 40px;
      line-height: 16px;
      text-align: center;
      font-size: 16px;
      color: #4493f5;
      letter-spacing: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
    }
    .regist :hover {
      width: 58px;
      height: 40px;
      background: #73AFF6;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
    }
    .device {
      width: 1px;
      height: 20px;
      background-color: #4493F5;
      position: relative;
      float: left;
    }
    .login {
      width: 58px;
      height: 40px;
      line-height: 16px;
      text-align: center;
      font-size: 16px;
      color: #4493f5;
      letter-spacing: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
    }
    .login :hover {
      width: 58px;
      height: 40px;
      background: #73AFF6;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
    }
  }
}

.bottompart {
  margin-top: 29px;
}
/deep/ .ant-menu-horizontal {
  border-bottom: 0px;
  margin-top: -9px;
  margin-left: 15px;
  background: rgba(0,122,255,0);
  color: #fff;
}
/deep/ .ant-menu-horizontal > .ant-menu-item-selected {
  color: #fff;
  border-bottom: 6px solid #4393F5;
  font-size: 18px;
  letter-spacing: 0;

  // padding-bottom: 12px;
  // transform: scale(1.05);
}
/deep/ .ant-menu-horizontal > .ant-menu-item-active {
  color: #fff;
  border-bottom: 6px solid #4393F5;
  font-size: 18px;
  letter-spacing: 0;

  // padding-bottom: 12px;
  // transform: scale(1.05);
}
/deep/ .ant-menu-item {
  margin: -5px 30px 0px 0px;
  padding: 0px 0px;
  // padding-bottom: 12px;
  border-bottom: 5px solid transparent;
}
/deep/ .ant-menu-item {
  transition: none;
}
/deep/ .ant-menu-item:hover {
  font-size: 22px !important;
}
.menuTitle :hover {
  color: #2d84ff;
}
.menuTitle {
  width: 84px;
  height: 39px;
  display: flex;
  text-align: center;
  line-height: 39px;
  font-size: 14px;
  div {
    width: 100%;
    // margin-top: 6px;
  }
}
.xldBox{
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  margin-left: 10px;
  width: 50px;
  height: 40px;
  position: relative;
}
.xldImg{
  width: 30px;
  height: 30px;
}
.unReadNum{
  width: 28px;
  height: 28px;
  position: absolute;
  top: -5px;
  right: 0;
  color: #fff;
  background: #f00;
  border-radius:50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: 18px;
}
.bell-large-number {
  width: 33px;
  height: 28px;
  position: absolute;
  top: -3;
  right: 0;
  color: #fff;
  background: #f00;
  border-radius:50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: 18px;
}
.area-select-box {
  // width: 1200px;
  // margin: auto;
  // // position: fixed;
  // float: left;
  // left: calc(28%);
  // top: 60px;
}
</style>
